import angular from 'angular';
import { isNumber, isUndefined, keys } from 'lodash';
import permit from 'common/helpers/permit';

import {} from './od-incrementor.less';

module.exports = angular.module('market.components.od-incrementor', [
])
.component('odIncrementor', {
  template: require('./od-incrementor.jade')(),
  bindings: {
    value: '=',
    type: '@?',
    min: '<?',
    max: '<?',
    increment: '<?',
  },
  controller: class {
    constructor(weekdayWorkCalendar) {
      this.TYPES = {
        'number': {
          plus: (value, increment) => value + increment,
          minus: (value, increment) => value - increment,
          lessOrEqual: (a, b) => a <= b,
        },
        'currency': {
          plus: (value, increment) => value + increment,
          minus: (value, increment) => value - increment,
          lessOrEqual: (a, b) => a <= b,
        },
        'date': {
          plus: (value, increment) => value.clone().add(increment, 'days'),
          minus: (value, increment) => value.clone().subtract(increment, 'days'),
          lessOrEqual: (a, b) => a.isSameOrBefore(b, 'days'),
        },
        'work-date': {
          plus: (value, increment) => weekdayWorkCalendar.workdaysAfter(value, increment),
          minus: (value, increment) => weekdayWorkCalendar.workdaysBefore(value, increment),
          lessOrEqual: (a, b) => a.isSameOrBefore(b, 'days'),
        },
      };

      this.type = permit(this.type, keys(this.TYPES)) || 'number';
      if (!isNumber(this.increment)) {
        this.increment = 1;
      }
    }

    minus() {
      let newValue = this.TYPES[this.type].minus(this.value, this.increment);
      if (isUndefined(this.min) || this.TYPES[this.type].lessOrEqual(this.min, newValue)) {
        this.value = newValue;
      }
    }

    plus() {
      let newValue = this.TYPES[this.type].plus(this.value, this.increment);
      if (isUndefined(this.max) || this.TYPES[this.type].lessOrEqual(newValue, this.max)) {
        this.value = newValue;
      }
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-incrementor.js
 **/